import { PriceProps } from "../../../../PriceProps";
import { ProductInfo } from "../ProductInfo";
import { ProductPriceDetails } from "../ProductPriceDetails";
import css from "./ProductPriceSection.module.scss";

type ProductPriceSectionProps = PriceProps & {
  isDesktop: boolean;
};

export const ProductPriceSection = ({
  isLoading,
  blurPrice,
  variants,
  selected,
  onChange,
  activeVariant,
  isDesktop,
  isBlur,
  showSelectPlatformPrompt,
}: ProductPriceSectionProps) => {
  return (
    <div className={css.productBlock}>
      <ProductPriceDetails
        isLoading={isLoading}
        isBlur={isBlur}
        variants={variants}
        selected={selected}
        onChange={onChange}
      />
      <ProductInfo
        isLoading={isLoading}
        isBlur={isBlur}
        blurPrice={blurPrice}
        showSelectPlatformPrompt={showSelectPlatformPrompt}
        activeVariant={activeVariant}
        isDesktop={isDesktop}
      />
    </div>
  );
};
